export default class DtStub {
    constructor() {
        this.col = null;
        this.term = null;
        this.drawn = false;
        this.isVisible = null;
    }

    column(col) {
        this.col = col;
        return this;
    }

    columns() {
        return this;
    }

    search(term, regex?, smart?) {
        this.term = term;
        return this;
    }

    draw() {
        this.drawn = true;
    }

    visible(val) {
        this.isVisible = val;
        return val;
    }
}